export default "__VITE_ASSET__CLpQ_nYO__"